import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Alert,
  AlertTitle,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import Buttons from "../Controls/Buttons/Button";

const DeleteConfirmationPopup = ({
  open,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  onConfirm,
  onCancel,
  text = "Delete",
  loading = false,
  warningMessage,
}) => {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent sx={{ minWidth: "500px" }}>
        <DialogContentText>{message}</DialogContentText>
        {warningMessage && (
          <Alert
            severity="warning"
            icon={<WarningAmberRoundedIcon fontSize="inherit" />}
            sx={{
              mt: 2,
              alignItems: "flex-start",
              border: "1px solid",
              borderColor: "warning.light",
              borderRadius: 2,
              backgroundColor: "#FFF8E1",
              color: "#5D4037",
              "& .MuiAlert-icon": {
                mt: 0.25,
                color: "#F59E0B",
                fontSize: 26,
              },
              "& .MuiAlert-message": {
                py: 0.25,
              },
            }}
          >
            <AlertTitle sx={{ mb: 0.25, fontWeight: 700, color: "#92400E" }}>
              Important notice
            </AlertTitle>
            {warningMessage}
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>
        <Buttons
          size="small"
          text={text}
          onClick={onConfirm}
          loading={loading}
        />
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationPopup;
